<template>
  <div class="px-8 py-1">
    <v-container grid-list-xl fluid class="px-0">
      <v-flex xs12 mb-3>
        <h2 class="darkblue--text fs-16 lh-16 font-weight-700">
          TAXONOMY
        </h2>
        <v-breadcrumbs class="px-0" :items="breadcrumbs"></v-breadcrumbs>
      </v-flex>
      <v-card>
        <v-card-title>
          <v-flex xs9>
            {{ id ? 'Edit Taxonomy' : 'Create New Taxonomy' }}
          </v-flex>
          <v-flex xs3 class="text-right">
            <v-icon title="refresh" @click="getData()">refresh</v-icon>
          </v-flex>
        </v-card-title>
        <ValidationObserver ref="obs">
          <v-form @submit.prevent="save" class="pa-5">
            <v-layout row wrap>
              <v-flex xs6 class="pa-0">
                <ValidationProvider
                  name="Code"
                  rules="required"
                  v-slot="{ errors, valid }"
                >
                  <label class="darkblue--text pl-5">Code</label>
                  <v-text-field
                    id="code"
                    single-line
                    outlined
                    placeholder="Code"
                    dense
                    v-model="items.code"
                    required
                    class="px-5"
                    :error-messages="errors"
                    :success="valid"
                  ></v-text-field>
                </ValidationProvider>
              </v-flex>
              <v-flex xs6 class="pa-0">
                <ValidationProvider
                  name="Cost Element"
                  rules="required"
                  v-slot="{ errors, valid }"
                >
                  <label class="darkblue--text pl-5">Cost Element</label>
                  <v-autocomplete
                    id="code-group"
                    single-line
                    outlined
                    placeholder="Select Cost Element"
                    dense
                    v-model="items.code_cost_element"
                    required
                    class="px-5"
                    :items="costElements"
                    item-value="code"
                    item-text="desc"
                    :error-messages="errors"
                    :success="valid"
                  >
                    <template slot="selection" slot-scope="data">
                      {{ data.item.code }} - {{ data.item.desc }}
                    </template>
                    <template slot="item" slot-scope="data">
                      {{ data.item.code }} - {{ data.item.desc }}
                    </template>
                  </v-autocomplete>
                </ValidationProvider>
              </v-flex>
              <v-flex xs6 class="pa-0">
                <ValidationProvider
                  name="Cost Center"
                  rules="required"
                  v-slot="{ errors, valid }"
                >
                  <label class="darkblue--text pl-5">Cost Center</label>
                  <v-autocomplete
                    id="code-group"
                    single-line
                    outlined
                    placeholder="Select Cost Center"
                    dense
                    v-model="items.code_cost_center"
                    required
                    class="px-5"
                    :items="costCenters"
                    item-value="code"
                    item-text="desc"
                    :error-messages="errors"
                    :success="valid"
                  >
                    <template slot="selection" slot-scope="data">
                      {{ data.item.code }} - {{ data.item.desc }}
                    </template>
                    <template slot="item" slot-scope="data">
                      {{ data.item.code }} - {{ data.item.desc }}
                    </template>
                  </v-autocomplete>
                </ValidationProvider>
              </v-flex>
              <v-flex xs6 class="pa-0">
                <ValidationProvider
                  name="PCTR"
                  rules="required"
                  v-slot="{ errors, valid }"
                >
                  <label class="darkblue--text pl-5">PCTR</label>
                  <v-text-field
                    id="PCTR"
                    single-line
                    outlined
                    placeholder="PCTR"
                    dense
                    v-model="items.pctr"
                    required
                    class="px-5"
                    :error-messages="errors"
                    :success="valid"
                  ></v-text-field>
                </ValidationProvider>
              </v-flex>
              <v-flex xs6 class="pa-0">
                <ValidationProvider
                  name="MAT Group"
                  rules="required"
                  v-slot="{ errors, valid }"
                >
                  <label class="darkblue--text pl-5">MAT Group</label>
                  <v-text-field
                    id="mat"
                    single-line
                    outlined
                    placeholder="MAT Group"
                    dense
                    v-model="items.mat_group"
                    required
                    class="px-5"
                    :error-messages="errors"
                    :success="valid"
                  ></v-text-field>
                </ValidationProvider>
              </v-flex>
              <v-flex xs6 class="pa-0">
                <ValidationProvider
                  name="AR 1"
                  rules="required"
                  v-slot="{ errors, valid }"
                >
                  <label class="darkblue--text pl-5">AR 1</label>
                  <v-text-field
                    id="ar1"
                    single-line
                    outlined
                    placeholder="AR 1"
                    dense
                    v-model="items.ar1"
                    required
                    class="px-5"
                    :error-messages="errors"
                    :success="valid"
                  ></v-text-field>
                </ValidationProvider>
              </v-flex>
              <v-flex xs6 class="pa-0">
                <ValidationProvider
                  name="BPC"
                  rules="required"
                  v-slot="{ errors, valid }"
                >
                  <label class="darkblue--text pl-5">BPC</label>
                  <v-text-field
                    id="bpc"
                    single-line
                    outlined
                    placeholder="BPC"
                    dense
                    v-model="items.bpc"
                    required
                    class="px-5"
                    :error-messages="errors"
                    :success="valid"
                  ></v-text-field>
                </ValidationProvider>
              </v-flex>
              <v-flex xs6 class="pa-0">
                <ValidationProvider
                  name="Category"
                  rules="required"
                  v-slot="{ errors, valid }"
                >
                  <label class="darkblue--text pl-5">Category</label>
                  <v-text-field
                    id="category"
                    single-line
                    outlined
                    placeholder="Description"
                    dense
                    label="Category"
                    v-model="items.category"
                    class="px-5"
                    :error-messages="errors"
                    :success="valid"
                  ></v-text-field>
                </ValidationProvider>
              </v-flex>
            </v-layout>
            <v-card-actions class="text-right">
              <v-spacer></v-spacer>
              <v-flex xs2 right class="mr-4">
                <v-btn
                  id="btn-cancel"
                  dark
                  rounded
                  color="red"
                  block
                  :to="{ name: 'taxonomy' }"
                >
                  Cancel
                </v-btn>
              </v-flex>
              <v-flex xs2 right>
                <v-btn
                  id="btn-update"
                  dark
                  rounded
                  color="blue darken-3"
                  block
                  v-if="id"
                  type="submit"
                  >Update</v-btn
                >
                <v-btn
                  id="btn-save"
                  dark
                  rounded
                  color="blue darken-3"
                  block
                  v-else
                  type="submit"
                  >Save</v-btn
                >
              </v-flex>
            </v-card-actions>
          </v-form>
        </ValidationObserver>
      </v-card>
    </v-container>
    <progress-dialog :show="progressDialogLoading" text="Please wait">
    </progress-dialog>
  </div>
</template>

<script>
import ProgressDialog from '../../../components/progress_dialog';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import 'sweetalert2/src/sweetalert2.scss';

export default {
  components: { 'progress-dialog': ProgressDialog },
  $_veeValidate: {
    validator: 'new'
  },
  data() {
    return {
      isEdit: false,
      text: '',
      progressDialogLoading: true,
      name: '',
      items: {
        code: '',
        code_cost_element: null,
        code_cost_center: null,
        pctr: '',
        mat_group: '',
        ar1: '',
        bpc: '',
        category: ''
      },
      costElements: [],
      costCenters: [],
      loading: true,
      search: '',
      breadcrumbs: [
        {
          text: 'Master Data',
          disabled: true,
          href: 'breadcrumbs_dashboard'
        },
        {
          text: 'Taxonomy List',
          disabled: true,
          href: 'breadcrumbs_link_1'
        },
        {
          text: this.id ? 'Edit Taxonomy' : 'Create New Taxonomy',
          disabled: true,
          href: 'breadcrumbs_link_1'
        }
      ]
    };
  },
  props: ['id'],
  mounted() {
    this.getData();
  },
  methods: {
    getData() {
      this.getDataCost();
      this.clear();
      if (this.id) {
        this.getDetail();
      }
    },
    getDataCost() {
      this.progressDialogLoading = true;
      this.loading = true;

      const limit = 10000;
      this.$store
        .dispatch('costElement/getAll', { limit })
        .then(data => {
          if (data.code === 200) {
            this.costElements = data.data.result;
          } else {
            Swal.fire('Failed!', data.response.data.message.text_en, 'error');
          }
        })
        .catch(err => {
          Swal.fire('Failed!', err.response.data.message.text_en, 'error');
          this.progressDialogLoading = false;
          this.loading = false;
        });

      this.$store
        .dispatch('costCenter/getAll', { limit })
        .then(data => {
          this.progressDialogLoading = false;
          this.loading = false;
          if (data.code === 200) {
            this.costCenters = data.data.result;
          } else {
            Swal.fire('Failed!', data.response.data.message.text_en, 'error');
          }
        })
        .catch(err => {
          Swal.fire('Failed!', err.response.data.message.text_en, 'error');
          this.progressDialogLoading = false;
          this.loading = false;
        });
    },
    getDetail() {
      this.progressDialogLoading = true;
      this.loading = true;
      this.$store
        .dispatch('taxonomy/detail', this.id)
        .then(data => {
          this.progressDialogLoading = false;
          this.loading = false;
          if (data.code === 200) {
            this.items = data.data.result;
            this.loading = false;
          } else {
            Swal.fire('Failed!', data.response.data.message.text_en, 'error');
          }
        })
        .catch(err => {
          this.progressDialogLoading = false;
          this.loading = false;
          Swal.fire('Failed!', err.response.data.message.text_en, 'error');
        });
    },
    async clear() {
      this.items = {
        code: '',
        code_cost_element: null,
        code_cost_center: null,
        pctr: '',
        mat_group: '',
        ar1: '',
        bpc: '',
        category: ''
      };
      requestAnimationFrame(() => {
        this.$refs.obs.reset();
      });
    },
    async save() {
      const validated = await this.$refs.obs.validate();
      if (validated) {
        this.progressDialogLoading = true;
        this.loading = true;
        if (this.id) {
          this.$store
            .dispatch('taxonomy/update', { id: this.id, params: this.items })
            .then(data => {
              this.progressDialogLoading = false;
              this.loading = false;
              if (data.code === 200) {
                Swal.fire('Success!', data.message.text_en, 'success');
                this.clear();
                this.$router.push({
                  name: 'taxonomy'
                });
              } else {
                Swal.fire(
                  'Failed!',
                  data.response.data.message.text_en,
                  'error'
                );
              }
            })
            .catch(err => {
              console.log('error', err);
              Swal.fire('Failed!', err.response.data.message.text_en, 'error');
              this.progressDialogLoading = false;
              this.loading = false;
            });
        } else {
          this.$store
            .dispatch('taxonomy/create', this.items)
            .then(data => {
              this.progressDialogLoading = false;
              this.loading = false;
              if (data.code === 200) {
                Swal.fire('Success!', data.message.text_en, 'success');
                this.clear();
                this.$router.push({
                  name: 'taxonomy'
                });
              } else {
                Swal.fire(
                  'Failed!',
                  data.response.data.message.text_en,
                  'error'
                );
              }
            })
            .catch(err => {
              this.progressDialogLoading = false;
              this.loading = false;
              Swal.fire('Failed!', err.response.data.message.text_en, 'error');
            });
        }
      }
    }
  }
};
</script>
